export default {
  common: {
    menu: 'Menü',
    error: 'Fehler',
    no: 'Nein',
    search: 'Suche',
    selected: 'Ausgewählt',
    yes: 'Ja',
  },
  actions: {
    clear: 'Leeren',
  },
};
